module.exports = __webpack_public_path__ + "img/03.1c76dcee.png";